module.exports = __webpack_public_path__ + "static/novalac-c7b2a2732eeebf0db706e789ee8d759f.webm";